export default {
  /* onDashboard(state) {
    return (
      !!state.nodeCurrent.workspace.id &&
      !state.nodeCurrent.master.id &&
      !state.nodeCurrent.instance.id
    )
  }, */
}
